// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE
'use strict';

var Block = require("bs-platform/lib/js/block.js");
var Curry = require("bs-platform/lib/js/curry.js");
var React = require("react");
var Edit$Phonics = require("./Edit.bs.js");
var View$Phonics = require("./View.bs.js");

function str(prim) {
  return prim;
}

function toView(state) {
  if (state.tag) {
    return state;
  } else {
    return /* View */Block.__(1, [{
                word: state[0].word,
                display: /* DisplayPlay */0
              }]);
  }
}

function toEdit(state) {
  if (state.tag) {
    return /* Edit */Block.__(0, [{
                word: state[0].word,
                activeIndex: 0,
                display: /* DisplayPhonemeSelection */0
              }]);
  } else {
    return state;
  }
}

function PhonicsApp(Props) {
  var match = React.useReducer((function (state, action) {
          if (typeof action === "number") {
            if (action === /* ViewClicked */0) {
              return toView(state);
            } else {
              return toEdit(state);
            }
          } else if (action.tag) {
            if (state.tag) {
              return /* View */Block.__(1, [View$Phonics.reducer(state[0], action[0])]);
            } else {
              return state;
            }
          } else if (state.tag) {
            return state;
          } else {
            return /* Edit */Block.__(0, [Edit$Phonics.reducer(state[0], action[0])]);
          }
        }), /* Edit */Block.__(0, [Edit$Phonics.initialState]));
  var dispatch = match[1];
  var state = match[0];
  var tmp;
  tmp = state.tag ? React.createElement(View$Phonics.make, {
          dispatch: (function (viewAction) {
              return Curry._1(dispatch, /* ViewAction */Block.__(1, [viewAction]));
            }),
          state: state[0],
          onEditButtonClicked: (function (param) {
              return Curry._1(dispatch, /* EditClicked */1);
            })
        }) : React.createElement(Edit$Phonics.make, {
          state: state[0],
          dispatch: (function (editAction) {
              return Curry._1(dispatch, /* EditAction */Block.__(0, [editAction]));
            }),
          onViewButtonClicked: (function (param) {
              return Curry._1(dispatch, /* ViewClicked */0);
            })
        });
  return React.createElement("div", {
              className: "app"
            }, tmp);
}

var make = PhonicsApp;

exports.str = str;
exports.toView = toView;
exports.toEdit = toEdit;
exports.make = make;
/* react Not a pure module */
